import { gql } from "apollo-boost"

export const PhoneRecovery = gql`
  mutation PhoneRecovery(
    $uid: string,
    $phone: string,
    $email: string
  ){
    phoneRecovery(
        uid: $uid,
        phone: $phone,
        email: $email
    )
  }
`